import { action } from 'satcheljs/lib/legacy';
import { FeedbackViewState } from '../store/schema/FeedbackViewState';

export default action('setFeedbackMessage')(function setFeedbackMessage(
    state: FeedbackViewState,
    message: string
) {
    state.message = message || '';
});
